export const changePasswordPayloadToJSON = (payload: IProfileChangePasswordPayload): IProfileChangePasswordJson => {
	const { currentPassword, newPassword, newPasswordConfirmation } = payload

	return {
		current_password: currentPassword,
		new_password: newPassword,
		new_password_confirmation: newPasswordConfirmation,
	}
}
